import _Vue from 'vue';
import WxPopup from './WxPopup.vue';
export default {
  install(Vue: typeof _Vue) {
    Vue.prototype.$wxPopup = () => {
      console.log('what !');
      const Popup = Vue.extend(WxPopup);
      const popupInstance = new Popup().$mount();
      popupInstance.$data.pointOut = true;
      document.body.appendChild(popupInstance.$el);
    };
  },
};
